import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService, DataService, FireForesightService, SiteTypeService } from 'src/api/services';
import { User,Customer, CustomerSummary, StatusType, Status, Incident, Widget, Note, SiteTwin } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { Command } from 'src/api/models/command';
import { CommandParameter } from 'src/api/models/command-parameter';
import { ActivatedRoute } from '@angular/router';
import { IMultiSourceMultiValueWidget, TimeSeriesDetail } from 'src/app/models/dashboard';
import { AbstractDataService } from 'src/service/data.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { FireService } from 'src/service/fire.service';
import { Location, MapComponent } from 'src/app/components/map/map.component';
import { SmartImageComponent } from 'src/app/components/smart-image/smart-image.component';
import { SmartImageDetail, SmartImageListComponent } from 'src/app/components/smart-image-list/smart-image-list.component';
import { IconService } from 'src/service/icon.service';
import { CameraControllerComponent } from 'src/app/components/camera-controller/camera-controller.component';

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-fire-foresight-incident-embedded',
  templateUrl: './fire-foresight-incident-embedded.component.html',
  styleUrls: ['./fire-foresight-incident-embedded.component.css']
})
export class FireForesightIncidentEmbeddedComponent implements OnInit, OnDestroy {
  public zoom: Boolean;
  public list : StatusType [];
  @Input() public incidentId: number;
  @Input() public fullScreen: boolean = true;
  //public incident: Incident;
  public liveWidget: IMultiSourceMultiValueWidget;
  public latestImageUrl: string;
  public liveExpand: boolean = false;
  public selectedNote: Note;
  public newNote: string;
  public liveStreaming: boolean = false;
  public oldLocation: Location;
  public ptzBearing: number;
  public ptzElevation: number;
  public ptzZoom: number;
  
  constructor(
    public app: ApplicationConfigService,
    public cmd: CommandService,
    public security: AzureAuthService,
    private svc: FireForesightService, 
    public fire: FireService,
    private siteTypeService: SiteTypeService,
    private dataService: DataService,
    private toasterService: ToastrService,
    private data: DataService,
    private route: ActivatedRoute,
    private iconSvc: IconService) { 
    // console.log("fire-foresight-admin constructor")
  }

  ngOnInit(): void { 
    this.svc.FireForesightGetStatusTypes().subscribe(r=>{
      console.log("ngOnInit", r);
      this.list = r;
      // {statusId: 1, displayName: 'Unconfirmed', description: 'Initial state for all detections'}
    });

    if (this.incidentId){

      this.fire.getIncident(this.incidentId, i => {
        this.loadIncident();
      });
    }
  }

  ngOnDestroy(): void {

  }

  getSegments(){
    if (this.fire.twin && this.fire.twin.parameters){
      return Object.values(this.fire.twin.parameters).filter(f => f.bearing != null && !f.hidden).length;
    }
    return 0;
  }

  streamUrl : string;
  streamTimeout;
  timeout: number = 0;
  liveStream(){
    if (!this.liveStreaming){
      // only redirect the camera when you request live streaming
      this.cmd.CommandRunCommand({
        customerId: this.app.customerId,
        command: {
          siteUri: this.fire.camera.siteUri, 
          action: 'goto', 
          parameters: [
            { parameterName:'zoom', parameterValue:this.ptzZoom.toString()},
            { parameterName:'direction', parameterValue:this.ptzBearing.toString()},
            { parameterName:'elevation', parameterValue:this.ptzElevation.toString()}
          ]
        }
      }).subscribe(c => {
        this.toasterService.success(`Camera redirected to fire: ${Math.round(this.ptzBearing)} ${Math.round(this.ptzElevation)} ${this.ptzZoom}`);
      }, err => {
        this.toasterService.error("Failed to redirect camera to fire");
      });
    }
    /*this.ptz.ptzDirection = this.fire.incident.bearing;
    this.ptz.ptzElevation = this.fire.incident.elevation;
    this.ptz.ptzZoom = 4;*/

    if (this.streamTimeout != null) {
      clearTimeout(this.streamTimeout);
      this.timeout = 0;
    }

    if (this.liveStreaming){
      this.streamUrl = this.fire.camera?.manualCameraLatestUrl;
    } else {
      this.streamUrl = '/api/FireForesight/GetStream/' + this.app.customerId + '/' + this.fire.camera?.siteId;
      this.streamTimeout = setInterval(() => {
        if (this.timeout >= 100){
          this.liveStream();
          this.toasterService.success("Video Feed Timed Out");
          clearTimeout(this.streamTimeout);
          this.timeout = 0;
          setTimeout(() => {
            this.liveStreaming = false
            this.streamUrl = null;
          }, 1000);
        }else{
          this.timeout = this.timeout + 0.25;
        }
      }, 100);
    }

    this.liveStreaming = !this.liveStreaming;

    // todo: issue command to redirect camera in the direction of the incident
   
    //this.streamUrl = '/api/FireForesight/GetStream/' + this.app.customerId + '/' + this.fire.camera?.siteId;
    //this.liveStreaming = !this.liveStreaming;
  }
  
  


  detectionImages: SmartImageDetail[];
  latestImages: SmartImageDetail[];
  timeLapseLoading: boolean = false;
  loadTimelapse(){
    console.log('Loading Image History...')
    this.timeLapseLoading = true;
    const imageUri = this.fire.incident.imageFeedUri;
    if (imageUri){
      // now load the larger data set of images
      this.dataService.DataGetData({  customerId: this.app.customerId,
        request:{
          period: '-4h:1h', 
          type: 'media',
          timeZoneOffset: this.app.getTimeZoneOffset(null),
          forceEmbed: false,
          index: 0,
          publishedIdentifier: null,
          siteUri: null,
          timeSeries: {
            single:{ 
              variable: {
                uri: imageUri,
                transforms: null,   
              }          
            }
          }
        }
      }).subscribe(r => {
        //TimeSeries:{ Variable:{Uri:  imageUri}}, transforms: null, Period: '-4h:1h', Type:"media", TimeZoneOffset: 0}).subscribe(r => {
        //this.latestImageUrl = r.values[0].valueStr;
        this.latestImages = r.values.map(i => { return { src:i.valueStr, overlay: null, timeStamp: i.timeStamp } as SmartImageDetail });
        this.timeLapseLoading = false;
      }, err => {
        console.error(err);
      });
    }
  }

  canClickStatus(status: StatusType){

    var statusId = this.fire.incident.status.statusId
    if (statusId == 1  || statusId == 10) { // its a new detection
      if (status.statusId == 2 || status.statusId == 5){
        // allow "Investigating" or "Not a Fire"
        return true;
      }
    }
    if (statusId == 2) { // investigating
      if (status.statusId == 3){
        // allow "Confirmed"
        if (this.fire.incident.initialLocationLat == null && this.fire.incident.initialLocationLon == null){
          return false;
        }
        return true;
      }
      if (status.statusId == 5 || status.statusId == 7 || status.statusId == 4 || status.statusId == 11){
        // allow "Not a Fire" or "Watching" or "Confirmed but Ignore" or "Duplicate"
        return true;
      }
    }
    if (statusId == 3) { // confirmed
      if (status.statusId == 4 || status.statusId == 5 || status.statusId == 6 || status.statusId == 8 || status.statusId == 7){
        // allow "Escalated" or "Confirmed and Closed" or "Confirmed but Ignore" or "Not a Fire" or "Watching"
        return true;
      }
    }
    if (statusId == 8) { // escalated
      if (status.statusId == 4 || status.statusId == 5 || status.statusId == 6 || status.statusId == 7 || status.statusId == 9){
        // allow "Escalated" or "Confirmed and Closed" or "Confirmed but Ignore" or "Not a Fire"
        return true;
      }
    }
    if (statusId == 9) { // acknowledged
      if (status.statusId == 4 || status.statusId == 6){
        // allow "Escalated" or "Confirmed and Closed" or "Confirmed but Ignore" or "Not a Fire"
        return true;
      }
    }
    if (statusId == 11) { // duplicate
      if (status.statusId == 4){
        // allow "Confirmed and Ignore"
        return true;
      }
    }
    
    if (statusId == 7) { // watching
      if (status.statusId == 8){
        // allow "Escalated"
        if (this.fire.incident.initialLocationLat == null && this.fire.incident.initialLocationLon == null){
          return false;
        }
        return true;
      }
      if (status.statusId == 4 || status.statusId == 5 || status.statusId == 6){
        // allow "Escalated" or "Confirmed and Closed" or "Confirmed but Ignore" or "Not a Fire"
        return true;
      }
    }

    
    
    // anything else - can return to investigating
    if (status.statusId == 2){
      // allow "Investigating"
      return true;
    }
    return false;
  }

  loadIncident(){
    if (this.fire.incident){
      this.ptzBearing = this.fire.incident.bearing;
      this.ptzElevation = this.fire.incident.elevation;
      this.ptzZoom = 4;
      if (this.streamTimeout){
        clearTimeout(this.streamTimeout);
      }
      this.liveStreaming = false;
      this.streamUrl = null;
      this.latestImages = null;
      this.timeLapseLoading = false;
      this.fire.getCamera(this.fire.incident.site.siteId, false, c => {
        //var fov =  360 / Math.max(Object.values(this.fire.twin.parameters).filter(f => f.bearing != null && !f.hidden).length,2);
      });
      console.log("Incident", this.fire.incident);
      const imageUri = this.fire.incident.imageFeedUri;
      if (imageUri != null){
        // quickly load the latest image
        this.dataService.DataGetData({ 
          customerId: this.app.customerId, 
          request:{
            period: 'latest', 
            type: 'media',
            timeZoneOffset: this.app.getTimeZoneOffset(null),
            forceEmbed: false,
            index: 0,
            publishedIdentifier: null,
            siteUri: null,
            timeSeries: {
              single: {
                variable: {
                  uri: imageUri,
                  transforms: null,   
                }        
              }  
            }
          }
        })
        .subscribe(r => {
          this.latestImages = r.values.map(i => { return { src:i.valueStr, overlay: null, timeStamp: i.timeStamp } as SmartImageDetail });          
        });
      }
      this.liveWidget = {name:"Live",showTitle:false, realTime:false, period:'-1h:1h',refreshInterval:0,dynamicTimeSeriesList:[],timeSeriesList:[{uri:'in-restapi-restapi-southsisters-288',forceEmbed:false,sourceType:'media'} as TimeSeriesDetail]} as IMultiSourceMultiValueWidget;
      this.detectionImages = this.fire.incident.detections.map(i => { return { src:i.imageUrl, overlay: i.detectionMetaData, timeStamp: i.firstDetected } as SmartImageDetail });
    }
  
  }

  updateStatus(status: StatusType){
    this.fire.incident.status = status;
    this.fire.update(this.fire.incident, () => {
      this.toasterService.success("Updated","Incident");
      // only move to the next incident if you say "Not a Fire"
      if (this.fire.incident.status.statusId == 5){
        this.fire.next(() => this.loadIncident());
      }
    });
  }

  getIcon(site: SiteTwin, pins: any[]){
    const icon = {icon: pins[site.siteType] ?? pins["blueSelected"]};
    return icon;
  }

  addNewNote(){
    this.svc.FireForesightAddNote({incidentId:this.incidentId, notes:this.newNote}).subscribe(n => {
      this.fire.incident.notes.push(n);
      this.newNote = "";
    })
  }


  deepClone(obj) { if (obj === null || typeof obj !== 'object') { return obj; } if (obj instanceof Date) { return new Date(obj); } if (obj instanceof Array) { const arrCopy = []; for (let i = 0; i < obj.length; i++) { arrCopy[i] = this.deepClone(obj[i]); } return arrCopy; } if (obj instanceof Object) { const objCopy = {}; for (const key in obj) { if (obj.hasOwnProperty(key)) { objCopy[key] = this.deepClone(obj[key]); } } return objCopy; } throw new Error('Unable to copy object! Its type isn\'t supported.'); }

}
